/* eslint-disable no-nested-ternary */
import React, { useContext, useState } from 'react';

// -----------------LIBRARIES IMPORTS------------------- //
import {
	Button,
	Input,
	ModalConfirmation,
	Typography,
} from 'design_system/src';

// -----------------DATA IMPORTS------------------- //
import moment from 'moment';

import { handleEventGoogle } from 'models/shared/helpers/googleAnalytics';

// -----------------STATIC IMPORTS------------------- //
import '../../../ozoner.scss';
import { ReactComponent as Reject } from 'design_system/src/static/icons/delete-folder.svg';
import { LightTooltip } from 'components/hocs/tooltip/Tooltip';
import { informativeMessage } from 'components/hocs/messages/messages';
import {
	FormStatus,
	RevivePreOfferProfileEnum,
	RevivePreOfferProfileValues,
} from 'models/financial-form/enums/financial-form.enums';
import { updateFinancialForm } from 'models/financial-form/controllers/financial-form.controller';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { ozonerContext } from '../../OzonerContext';

const profileOptions = Object.values(RevivePreOfferProfileEnum)
	.filter((value) => value !== RevivePreOfferProfileEnum.withoutCirculo)
	.map((value) => ({
		label: RevivePreOfferProfileValues[value],
		value,
	}));

function ExpiredSection() {
	const { updateFormData, financialForm } = useContext(ozonerContext);
	const [openRevive, setOpenRevive] = useState(false);
	const [profile, setProfile] = useState<RevivePreOfferProfileEnum | ''>('');
	const [loading, setLoading] = useState(false);

	const reviveSolicitud = (selectedProfile?: RevivePreOfferProfileEnum) => {
		setLoading(true);
		updateFinancialForm(financialForm.form._id, {
			status: FormStatus.pending,
			...(selectedProfile ? { revivePreOfferProfile: selectedProfile } : {}),
		})
			.then((newForm) => {
				toasterNotification({
					msg: 'Solicitud Exitosa',
					style: 'light',
					toasterType: toasterOptions.success,
				});
				updateFormData(newForm);
				setOpenRevive(false);
				setLoading(false);
			})
			.catch((e) => {
				commonErrorHandler(e);
				setLoading(false);
			});
		handleEventGoogle(
			'BTN_Pb_request_revive',
			'Panda Solicitudes',
			'click in revive request button',
		);
	};

	return (
		<>
			{informativeMessage(
				'Solicitud caducada por inactividad:',
				'',
				'neutral_1000',
				'neutral_400',
			)}
			<div
				id="validate-soli-ozoner"
				className="p_md border_b_solid border_1 border_neutral_400 display_flex flex_col"
			>
				<LightTooltip
					title={
						financialForm?.form?.updatedAt &&
						!moment(financialForm.form.updatedAt).isBefore(
							moment().subtract(3, 'month'),
						)
							? ''
							: 'La solicitud tiene mas de 3 meses, no es posible restaurarla'
					}
				>
					<div className="w_100_per">
						<Button
							scale="small"
							color="primary"
							onClick={() => setOpenRevive(true)}
							className="w_100_per"
							disabled={
								financialForm?.form?.updatedAt
									? moment(financialForm.form.updatedAt).isBefore(
											moment().subtract(3, 'month'),
									  )
									: true
							}
						>
							Restablecer solicitud
						</Button>
					</div>
				</LightTooltip>
				{openRevive && (
					<ModalConfirmation
						openConfirmation={openRevive}
						handleClose={() => setOpenRevive(false)}
						icon={<Reject className="text_primary_300" />}
						widthDesktop={40}
						isConfirmationLoading={false}
						actions={[
							{
								label: 'Cancelar',
								color: 'grey',
								action: () => setOpenRevive(false),
							},
							{
								label: 'Restablecer',
								color: 'primary',
								action: () =>
									reviveSolicitud(profile as RevivePreOfferProfileEnum),
								disabled: !profile || loading,
							},
						]}
					>
						<>
							<Typography scale="large" weight="600" className="m_b_xs">
								Restablecer solicitud
							</Typography>
							<Typography
								scale="medium"
								weight="400"
								className="m_b_md"
								textColor="neutral_700"
							>
								Selecciona bajo qué perfil se debe generar la nueva preoferta
							</Typography>
							<Input
								title="Perfil"
								name="revivePreOfferProfile"
								type="radio"
								inputClassName=""
								options={profileOptions}
								value={profile}
								onChange={(e: any) => setProfile(e.target.value)}
								className="w_100_per"
							/>
						</>
					</ModalConfirmation>
				)}
			</div>
		</>
	);
}
export default ExpiredSection;
